import { first } from 'rxjs/operators';
import { RateService, Rate } from '../rate-yieldmax.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RateComponent } from '../rate-yieldmax/rate-yieldmax.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { from } from 'rxjs';

@Component({
    selector: 'app-rate-yieldmax-list',
    templateUrl: './rate-yieldmax-list.component.html',
    styleUrls: ['./rate-yieldmax-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RateListComponent implements OnInit {
	constructor(
		private rateService: RateService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private activatedRoute: ActivatedRoute,
		private datePipe: DatePipe,
		private dialog: MatDialog,
	) {
		this.statuses = rateService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	rates: any;
	rate: Rate;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	//URL Filter
	filterCreateDay: any;
	filterUpdateDay: any;

	columns: any[] = [
		{ field: 'rateId', header: 'Id', width: 'auto' },
		{ field: 'createDate', header: 'Create Date', width: 'auto' },
		{ field: 'lastUpdate', header: 'Update Date', width: 'auto' },
		{ field: 'analyzedDate', header: 'Analyzed Date', width: 'auto' },
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.activatedRoute.queryParamMap.subscribe(params =>
			{
				this.filterCreateDay = params.get('createDate');
				this.filterUpdateDay = params.get('updateDate');;
			});
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: -1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-rate-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.filterCreateDay != null)
			{
				let filterCreateDay = this.addLocalTimeToDateTime(new Date(this.filterCreateDay));
				let date = this.datePipe.transform(filterCreateDay, 'yyyy-MM-ddThh:mm');
				event.filters['createDate'] = {"value":date,"matchMode":"in"};
			}

			if(this.filterUpdateDay != null)
			{
				let filterUpdateDay = this.addLocalTimeToDateTime(new Date(this.filterUpdateDay));
				let date = this.datePipe.transform(filterUpdateDay, 'yyyy-MM-ddThh:mm');
				event.filters['lastUpdate'] = {"value":date,"matchMode":"in"};
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.rateService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.rates = res.data.rates;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.rates = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(rate: Rate) {
		try {
			this.formLoading = true;
			this.rateService.update(rate)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.rates.map((rate, i) => {
							if (rate.rateId === res.data.rate.rateId) {
								this.rates[i] = res.data.rate;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(rate: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(rate));

			this.formLoading = true;
			this.rateService.delete(rate.rateId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.rates.splice(this.rates.indexOf(rate), 1);
						this.recordTotal = this.rates.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Rate ' + rate.rateId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Rate ' + rate.rateId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Rate'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRateCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(rate: Rate) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			rate: rate,
			title: 'Edit Rate'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRateCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRateCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRateCB(rate: Rate) {
		console.log('Adding Rate: ' + JSON.stringify(rate));
		// if we don't have a rates array yet...
		if (!this.rates) {
			this.rates = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.rates.unshift(rate);

		// no idea what this is but it is required to update the array
		this.rates = [...this.rates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rate ' + rate.rateId + ' Added', life: 3000 });
	}

	updateRateCB(rate: Rate) {
		console.log('Updating Rate: ' + JSON.stringify(rate));
		let itemIndex = this.rates.findIndex((item: any) => item.rateId === rate.rateId);
		this.rates[itemIndex] = rate;

		// no idea what this is but it is required to update the array
		this.rates = [...this.rates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rate ' + rate.rateId + ' Updated', life: 3000 });
	}

	deleteRateCB(rate: Rate) {
		console.log('Removing Rate: ' + rate);
		this.rates.splice(this.rates.indexOf(rate), 1);
		this.recordTotal = this.rates.length;

		// no idea what this is but it is required to update the array
		this.rates = [...this.rates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rate ' + rate.rateId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.rates ? this.first === (this.rates.length - this.rows) : true; }
	isFirstPage(): boolean { return this.rates ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(rate: any) {
		if (rate?.status) {
			const status = this.statuses.find((e: any) => e.value == rate.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
